import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function HolidayModal({
  show,
  setShow,
  year,
  token,
}) {
  const [holidays, setHolidays] = useState([]);

  useEffect(() => {
    if (!show) return;

    const fetchHolidays = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/employeeinfos/getHolidays`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              year: year,
            },
          }
        );

        setHolidays(res.data.rows || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchHolidays();
  }, [show, year, token]);

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Holidays List {year}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShow(false)}
            ></button>
          </div>
          <div className="modal-body">
            <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Holiday</th>
              <th>Day</th>
            </tr>
          </thead>

          <tbody>
            {holidays.map((holiday) => (
              <tr key={holiday.id}>
                <td>{holiday.holiday_date}</td>
                <td>{holiday.holiday_name}</td>
                <td>{holiday.day_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShow(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}